import { Component, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(): void {}

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <main className="error-screen">
          <span className="error-screen__icon">!</span>
          <h1>La aplicación encontró un problema</h1>
          <p>Recarga la página. Si continúa, contacta al administrador.</p>
          <button className="button button--primary" onClick={() => window.location.reload()} type="button">
            Recargar aplicación
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}
